import React from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { editUser } from '~/services/api';

export default function FormConfig({ children, onSubmit }) {
  const { t } = useTranslation();
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[.+!@#$%^&*])(?=.{8,20})/;

  const handleSubmit = async (values, { setSubmitting }) => {
    // Form data will be sent here if everything is valid
    try {
      await editUser(values);
      toast.success(t('editPasswordSuccess'));
    } catch (err) {
      toast.error(t('editPasswordError'));
    } finally {
      onSubmit();
    }
    setSubmitting(false);
  };

  return (
    <Formik
      initialValues={{
        oldPassword: '',
        plainPassword: '',
        passwordConfirmation: '',
      }}
      onSubmit={handleSubmit}
      validationSchema={Yup.object().shape({
        oldPassword: Yup.string()
          .matches(passwordRegex, t('passwordFormatValidationError'))
          .required(t('passwordIsRequiredValidationError')),
        plainPassword: Yup.string()
          .matches(passwordRegex, t('passwordFormatValidationError'))
          .required(t('newPasswordIsRequiredValidationError')),
        passwordConfirmation: Yup.string()
          .oneOf([Yup.ref('plainPassword'), null], t('passwordsMustMatch'))
          .required(t('confirmPasswordIsRequiredValidationError')),
      })}
    >
      {children}
    </Formik>
  );
}

FormConfig.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
  onSubmit: PropTypes.func,
};

FormConfig.defaultProps = {
  onSubmit: () => {},
};
